export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-4">
          爆料投稿入口
        </h2>
        <div className="bg-foreground-950 rounded-3xl p-8 md:p-12 text-white">
          <h3 className="text-xl md:text-2xl font-heading font-bold mb-3">有猛料？匿名投稿</h3>
          <p className="text-foreground-300 text-sm mb-8 leading-relaxed max-w-md mx-auto">
            我们提供绝对匿名的投稿通道，所有爆料信息均经过加密传输。你的身份完全不可追溯，经核实的猛料将获得优先展示和奖励。深夜吃瓜，从你开始。
          </p>
          <div className="border-b border-foreground-600 pb-2 mb-6 max-w-sm mx-auto">
            <input
              type="text"
              placeholder="输入你的爆料线索..."
              className="w-full bg-transparent text-white text-sm outline-none placeholder:text-foreground-500 text-center"
              readOnly
            />
          </div>
          <button className="inline-flex items-center gap-2 px-8 py-3 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-foreground-100 transition-all duration-200 whitespace-nowrap cursor-pointer" type="button">
            立即提交
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}